import react from "react";
import News from "../../components/news/News";
import { Helmet } from "react-helmet";

const Newspage = () => {

  return (
    <>
      <Helmet>
        <title>
          Latest Gold, Stock Market & Financial News | Gold-Rate-Today.com
        </title>

        <meta
          name="description"
          content="Get the latest updates on gold prices, GST reforms, stock market trends, and international finance news. Stay informed with live updates and global financial insights."
        />
        <meta
          name="keywords"
          content="gold news, stock market news, GST update, international finance news, bullion news, gold trend India, economy news"
        />

        {/* Open Graph for social sharing */}
        <meta property="og:title" content="Latest Gold, Stock Market & GST News" />
        <meta
          property="og:description"
          content="Stay updated with live gold trends, GST reforms, and Indian stock market insights. Brought to you by Gold-Rate-Today.com"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://gold-rate-today.com/news" />
        <meta
          property="og:image"
          content="https://gold-rate-today.com/images/gold-news-banner.jpg"
        />

        {/* Twitter card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Latest Gold & Financial News | Gold-Rate-Today.com"
        />
        <meta
          name="twitter:description"
          content="Read the latest news on gold, GST, and Indian financial markets. Live updates and insights daily."
        />
        <meta
          name="twitter:image"
          content="https://gold-rate-today.com/images/gold-news-banner.jpg"
        />

        <link rel="canonical" href="https://gold-rate-today.com/news" />

        {/* JSON-LD Structured Data for News Page */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "NewsMediaOrganization",
            "name": "Gold-Rate-Today News",
            "url": "https://gold-rate-today.com/news",
            "logo": "https://gold-rate-today.com/images/logo.png",
            "description": "Daily gold and finance news updates, including live gold rates, GST changes, stock trends, and global market insights."
          }
        `}</script>
      </Helmet>

      {/* international-news start */}
      <News heading="International News" api="https://gnews.io/api/v4/search?q=tariff&lang=en&max=5&apikey=197836aefe5d224564223fa9660e5c0e" />

      {/* international-news end */}

      {/* gold news start */}
      <News heading="Gold trend" api="https://gnews.io/api/v4/search?q=gold&lang=en&country=in&max=5&apikey=197836aefe5d224564223fa9660e5c0e" />
      {/* gold news end */}

      {/* gst news start */}
      <News heading="GST 2.0 Slab" api="https://gnews.io/api/v4/search?q=gst&lang=en&country=in&max=5&apikey=197836aefe5d224564223fa9660e5c0e" />
      {/* gst news end */}

      {/* stocks news start */}
      <News heading="stocks" api="https://gnews.io/api/v4/search?q=stock%20market&lang=en&country=in&max=5&apikey=197836aefe5d224564223fa9660e5c0e" />
      {/* stocks news end */}
    </>
  )
}

export default Newspage;